export const mapReviewStatus = ({ record, reviewStatusCounts }) => {
  const noReview = { color: "grey", text: "No review" };
  if (!reviewStatusCounts || reviewStatusCounts.length < 1) {
    return noReview;
  }

  const review = record.compliance.review;
  const currentReviewStatus = record.compliance.currentReviewStatus;

  const due = reviewStatusCounts.find((x) => x.key === 3);
  const notDue = reviewStatusCounts.find((x) => x.key === 4);

  // Direct index mapping approach
  if (review?.isDue) return due;
  if (review?.isNotDue) return notDue;
  if (currentReviewStatus?.name === "No Review") return noReview;

  return noReview;
};

export const capitalized = (str) =>
  str.replace(/^./, (char) => char.toUpperCase());

export const mapCustomerStatus = (selectedCustomer) =>
  selectedCustomer
    ? selectedCustomer.isVulnerable
      ? "Vulnerable Customer"
      : selectedCustomer.isTakingABreak
        ? "Temporary Break"
        : selectedCustomer.isBarred
          ? "Permanently Barred"
           : selectedCustomer.isSelfExcluded
           ? "Internal Self Exclusion"
           : "Normal"
    : "Normal";

export const mapStatusToCustomer = ({ customerStatus, customer }) => {
  if (!customer || !customerStatus) return;
  const status = customerStatus.value;

  const updatedCustomer = {
    ...customer,
    isNormal: false,
    isVulnerable: false,
    isTakingABreak: false,
    isBarred: false,
    isSelfExcluded: false,
  };

  status === "isNormal"
    ? (updatedCustomer.isNormal = true)
    : status === "isVulnerable"
      ? (updatedCustomer.isVulnerable = true)
      : status === "isTakingABreak"
        ? (updatedCustomer.isTakingABreak = true)
        : status === "isBarred"
          ? (updatedCustomer.isBarred = true)
          : status === "isInternalExcluded"
            ? (updatedCustomer.isSelfExcluded = true)
          : (updatedCustomer.isNormal = true);

  return updatedCustomer;
};

export const mapCustomerStatusOption = ({ customer, customerStatusOptions }) =>
  customer
    ? customer.isVulnerable
      ? customerStatusOptions[1]
      : customer.isTakingABreak
        ? customerStatusOptions[2]
        : customer.isBarred
          ? customerStatusOptions[3]
           : customer.isSelfExcluded
           ? customerStatusOptions[4]
           : customerStatusOptions[0]
    : customerStatusOptions[0];

export const mapCustomerReviewStatus = (record) => {
  const status = record?.customer?.currentReview;

  const due = { color: "green", content: "Due", value: 1 };
  const notDue = { color: "orange", content: "Not Due", value: 2 };
  const none = { color: "grey", content: "No Review", value: 4 };
  const completed = { color: "blue", content: "Completed", value: 3 };
  const inProgress = { color: "purple", content: "In Progress", value: 5 };
  const isAwaitingApproval = { color: "pink", content: "Awaiting Approval", value: 6 };

  return status?.isDue
    ? due
    : status?.isNotDue
      ? notDue
      : status?.isClosed
        ? completed
        : status?.isInProgress
          ? inProgress
          : status?.isAwaitingApproval
            ? isAwaitingApproval
        : none;
};


export const mapCustomerStatusToColor = (state) =>
  state
    ? state === "Vulnerable Customer"
      ? { color: '#ed6c02', backgroundColor: '#fff3e0'}
      : state === "Temporary Break"
        ? { color: '#1976d2', backgroundColor: '#e3f2fd' }
        : state === "Permanently Barred"
          ? { color: '#ff0000', backgroundColor: '#ffe6e6' }
            : state === "Internal Self Exclusion"
            ? { color: '#9c27b0', backgroundColor: '#f3e5f5' }
            : { color: '#2e7d32', backgroundColor: '#e8f5e9' }
      : { color: '#2e7d32', backgroundColor: '#e8f5e9' }